import { t } from "i18next"
import { useUnit } from "effector-react"
import { InlineMessage, Input, Label, Link, Typography } from "@callcenter/design-system"
import { FormErrors } from "@callcenter/effector-helpers"

import { userAccountModel } from "../../models"

import mainStyles from "../../shared/styles.module.pcss"
import styles from "./change-password-form.module.pcss"

export const ChangePasswordForm = () => {
  const formValue = useUnit(userAccountModel.$formValue)
  const isChangePasswordSectionVisible = useUnit(userAccountModel.$isChangePasswordSectionVisible)
  const formErrors = useUnit(userAccountModel.$formErrors)

  const actions = useUnit({
    handleChange: userAccountModel.handleChange,
    resetError: userAccountModel.resetError,
    handleBlur: userAccountModel.handleBlur,
    changePasswordSectionShown: userAccountModel.changePasswordSectionShown
  })

  return (
    <div className={mainStyles.selectSectionWrapper}>
      <input type="text" className={styles.hiddenInput} />
      <Typography.Body1>{t("userProfile_userProfileSidePanel_sectionHeading_password")}</Typography.Body1>

      {isChangePasswordSectionVisible ? (
        <>
          <InlineMessage type="info">{t("userProfile_userProfileSidePanel_password_info")}</InlineMessage>

          <Input.Password
            isAutoCompleteDisabled
            value={formValue.current_password}
            label={<Label label={t("userProfile_userProfileSidePanel_password_current")} />}
            placeholder={t("component_input_placeholder_enter")}
            onChange={(value) => actions.handleChange({ name: "current_password", value })}
            isError={Boolean(formErrors.current_password)}
            hint={
              formValue.current_password && formErrors.current_password
                ? FormErrors.pattern(t("userProfile_userProfileSidePanel_password_entity"))
                : formErrors.current_password
            }
          />

          <Input.Password
            isAutoCompleteDisabled
            value={formValue.password}
            label={<Label label={t("userProfile_userProfileSidePanel_password_new")} />}
            placeholder={t("component_input_placeholder_enter")}
            onBlur={() => actions.handleBlur("password")}
            onChange={(value) => {
              actions.resetError("password_confirmation")
              actions.handleChange({ name: "password", value })
            }}
            isError={Boolean(formErrors.password) || Boolean(formErrors.password_confirmation)}
            hint={formErrors.password}
          />

          <Input.Password
            isAutoCompleteDisabled
            value={formValue.password_confirmation}
            label={<Label label={t("userProfile_userProfileSidePanel_password_confirm")} />}
            placeholder={t("component_input_placeholder_enter")}
            onChange={(value) => actions.handleChange({ name: "password_confirmation", value })}
            onBlur={() => actions.handleBlur("password_confirmation")}
            isError={Boolean(formErrors.password_confirmation)}
            hint={formErrors.password_confirmation}
          />
        </>
      ) : (
        <Link onClick={() => actions.changePasswordSectionShown()} className={styles.changePasswordLink}>
          {t("userProfile_userProfileSidePanel_password_button")}
        </Link>
      )}
    </div>
  )
}
